/*jshint esversion: 6 */
<template>
  <div v-bind:style="style" class="timer fs-12">
    <span>
    <i class="icon-parking_info text-red"></i>
    <p class="paddingl10" style="padding-right:12px;display:inline;">本次缴费提车剩余时间:</p>
    <p style="display:inline;">{{content}}</p>
    </span>
  </div>
</template>
<style lang="scss">
  .timer{
    width:100%;
    text-align:center;
    background-color: #ffebf0;
    color:#ff6565;
  }
</style>
 <script>
  export default {
    data() {
        return {
          content: '',
        }
      },
      props: {
        time: {
          type: Number,
          default: ''
        },
        endText: {
          type: String,
          default: ''
        },
        style:{
          type:Object,
          default:null
        },
        callback: {
          type: Function,
          default: ''
        }
      },
      ready() {
        this.countdowm();
      },
      methods: {
        countdowm() {
          let that = this;
          let timer=setInterval(function() {
            let t = that.time;
            if (t > 0) {
              let day = Math.floor(t / 86400000);
              let hour = Math.floor((t / 3600000) % 24);
              let min = Math.floor((t / 60000) % 60);
              let sec = Math.floor((t / 1000) % 60);
              hour = hour < 10 ? "0" + hour : hour;
              min = min < 10 ? "0" + min : min;
              sec = sec < 10 ? "0" + sec : sec;
              let format = '';
              if (day > 0) {
                format = `${day}:${hour}:${min}:${sec}`;
              }
              if (day <= 0 && hour > 0) {
                format = `${hour}:${min}:${sec}`;
              }
              if (day <= 0 && hour <= 0) {
                format = `00:${min}:${sec}`;
              }
              that.content = format;
              that.time=that.time-1000
            } else {
              clearInterval(timer);
              that.content = that.endText;
              that.$dispatch('timer-reload');
            }
          }, 1000);
        },
        _callback() {
          if (this.callback && this.callback instanceof Function) {
          }
        }
      }
  } </script>